import React, { useState } from "react";
import styles from "./_css/searchBarGeoZone.module.css";
import { observer } from "mobx-react";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import { URLS } from "_configs/URLS";
import { PROPERTY_PURPOSE, PROPERTY_TYPE } from "properties/_models/PropertyMdl";
import { useHistory } from "react-router-dom";
import { propertiesBuyingStore } from "properties/_stores/propertiesBuyingStore";
import { propertiesRentingStore } from "properties/_stores/propertiesRentingStore";
import { TGeoZoneMdl } from "geoZones/_models/GeoZoneMdl";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { SearchBarResult } from "properties/searchBar/SearchBarResult";
import { Paper } from "@material-ui/core";
import { combineLoadingStates } from "_common/loaders/loadingStateUtils";
import { propertiesStore } from "properties/_stores/propertiesStore";
import { DEFAULT_MAP_COORDINATES_ZONE, fetchSearchProperties } from "_common/_utils/searchUtils";
import { SearchBarInput } from "properties/searchBar/SearchBarInput";
import { settingsStore } from "settings/_stores/settingsStore";
import clsx from "clsx";
import { TFilterType } from "admin/_common/resources/ResourceFilterMdl";

type Props = {
    isHomePage?: boolean;
    purpose: PROPERTY_PURPOSE;
    onSelectGeoZone?: (geoZone: TGeoZoneMdl) => void;
    onSelectProperty?: (aliasUrl: string) => void;
    propertyType?: PROPERTY_TYPE;
};

export const SearchBarGeoZoneAndProperties = observer((props: Props) => {
    const [value, setValue] = useState(geoZonesStore.geoZone?.name ?? "");
    const history = useHistory();
    const propertiesBuyingOrRentingStore =
        props.purpose === PROPERTY_PURPOSE.BUY ? propertiesBuyingStore : propertiesRentingStore;

    const onSelectGeoZone = (geoZone: TGeoZoneMdl) => {
        setValue(geoZone.name);
        geoZonesStore.setGeoZone(geoZone);
        propertiesStore.setLocationFromSearch(geoZone);
        propertiesBuyingStore.setLocationFromSearch(geoZone);
        propertiesRentingStore.setLocationFromSearch(geoZone);
        fetchSearchProperties(
            propertiesBuyingOrRentingStore,
            propertiesBuyingOrRentingStore.listsStores[props.purpose],
            history,
        );
        geoZonesStore.open(false);
        settingsStore.close();
    };

    return (
        <div className={"position_relative h-full w-full"}>
            <SearchBarInput
                onSelectGeoZone={(geoZone) => onSelectGeoZone(geoZone)}
                onSelectProperty={(urlAlias) => history.push(URLS.property(urlAlias))}
                isHomePage={props.isHomePage}
                purpose={props.purpose}
                value={value}
                setValue={setValue}
                onClickOnSearchIcon={() => {
                    {
                        const store =
                            props.purpose === PROPERTY_PURPOSE.BUY ? propertiesBuyingStore : propertiesRentingStore;
                        if (store.getListStore(props.purpose).filters.length < 2) {
                            store.getListStore(props.purpose).filters.push({
                                id: "purpose",
                                type: TFilterType.ENUM,
                                value: props.purpose,
                            });
                            store.getListStore(props.purpose).filters.push({
                                id: "location",
                                type: TFilterType.ZONE,
                                value: DEFAULT_MAP_COORDINATES_ZONE,
                            });
                        }
                        fetchSearchProperties(store, store.listsStores[props.purpose], history);
                    }
                }}
            />
            {geoZonesStore.isSearching && (
                <div id={"searchBarResult"} className={clsx(styles.searchResult, "w-full")}>
                    <Paper elevation={1} className={styles.container}>
                        <LoadableFromLoading
                            className={styles.loader}
                            noSpinner
                            loading={combineLoadingStates([
                                propertiesStore.propertiesSearchState,
                                geoZonesStore.geoZonesState,
                            ])}
                            renderer={() => (
                                <SearchBarResult
                                    purpose={props.purpose}
                                    onSelectGeoZone={(geoZone) => {
                                        onSelectGeoZone(geoZone);
                                    }}
                                    onSelectProperty={(urlAlias) => history.push(URLS.property(urlAlias))}
                                />
                            )}
                        />
                    </Paper>
                </div>
            )}
        </div>
    );
});
